import React from 'react'
import PropTypes from 'prop-types'

// 自作ユーティリティ・ツール
import * as def from '../define'
import { toHalfWidth, showMaintenanceDlg } from '../utils'

// Ajax
import { confirmMailAddress, registerInitialData, checkErrorCode } from '../webapi'

/**
 * 認証コードの照合
 */
export default class Authentication extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      vcd: '',
      msg: ''
    }
    this.handleTxtValidateCodeChange = this.handleTxtValidateCodeChange.bind(this)
    this.handleBtnContinueClick = this.handleBtnContinueClick.bind(this)
    this.handleBtnBackClick = this.handleBtnBackClick.bind(this)
    this.handleBtnCancelClick = this.handleBtnCancelClick.bind(this)
  }

  handleTxtValidateCodeChange(e) {
    let v = toHalfWidth(e.target.value)
    if (v !== this.state.vcd) {
      this.setState({ vcd: v })
    }
  }

  // 続行ボタン
  handleBtnContinueClick() {
    this.setState({ msg: '' })
    // 認証コードの確認
    this.props.callbacks.showMessage('WAIT', {})
    confirmMailAddress(this.props.info.token, this.props.info.adminMailAddress, this.state.vcd.replace(/ /g, ''))
      .then(
        function (obj) {
          // 認証OK - 登録
          registerInitialData(this.props.info.token, this.props.info)
            .then(
              function (obj) {
                // 登録成功 - 登録完了お知らせページヘ
                this.props.callbacks.showMessage('', {})
                if (typeof this.props.callbacks.stepChange === 'function') {
                  this.props.callbacks.stepChange(this.props.info, def.STEPS.ENTRY_COMPLETE)
                }
              }.bind(this)
            ).catch(
              function (err) {
                this.props.callbacks.showMessage('', {})
                if (checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
                  // メンテナンス中
                  const endTime = err.response.body.maintenanceEndTime
                  showMaintenanceDlg(this.props.callbacks.showMessage, endTime, true)
                  return
                }

                if (typeof this.props.callbacks.showMessage === 'function') {
                  if (err.status === 400) {
                    this.props.callbacks.showMessage('MSGBOX', { msgTitle: 'エラー', msgBody: JSON.parse(err.response.text).message, forceLogout: false })
                  } else {
                    this.props.callbacks.showMessage('APIERR', { msgBody: '\n' + err.status + '\n' + JSON.parse(err.response.text).message, forceLogout: false })
                  }
                }
              }.bind(this)
            )
        }.bind(this)
      ).catch(
        function (err) {
          this.props.callbacks.showMessage('', {})
          if (checkErrorCode(err, def.API_ERROR_CODE.MAINTENANCE)) {
            // メンテナンス中
            const endTime = err.response.body.maintenanceEndTime
            showMaintenanceDlg(this.props.callbacks.showMessage, endTime, true)
            return
          }

          if (err.status === 400) {
            this.setState({ msg: '認証コードが違います。' })
          } else {
            if (typeof this.props.callbacks.showMessage === 'function') {
              this.props.callbacks.showMessage('APIERR', { forceLogout: false })
            }
          }
        }.bind(this)
      )
  }

  // 戻るボタン
  handleBtnBackClick() {
    if (typeof this.props.callbacks.stepChange === 'function') {
      this.props.callbacks.stepChange(this.props.info, def.STEPS.INPUT_CONFIRM)
    }
  }

  // 中止ボタン
  handleBtnCancelClick() {
    if (typeof this.props.callbacks.logout === 'function') {
      this.props.callbacks.logout()
    }
  }

  render() {
    const boldStyle = { fontSize: 'large', fontWeight: 'bold' }
    return (
      <div className='appContent'>
        <div style={{ lineHeight: '2em', width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
          <div style={{ textAlign: 'left' }}>
            <span style={boldStyle}>まだ登録は完了していません。</span><br />
            入力いただいたメールアドレス <span style={boldStyle}>{this.props.info.adminMailAddress}</span> に、確認用の認証コードを記載したメールを送信いたしました。<br />
            メールをご確認いただき、記載されている認証コードを入力してください。
          </div>
          <div style={{ margin: '40px' }}>
            <label htmlFor='txtValidationCode'>認証コード: </label>
            <input type='text' id='txtValidationCode' value={this.state.vcd} onChange={this.handleTxtValidateCodeChange} />
          </div>
          <div style={{ color: 'red' }}>
            {this.state.msg}
          </div>
          <div>
            <button type='button' id='btnContinue' style={{ margin: '40px' }} disabled={this.state.vcd.length < 1} onClick={this.handleBtnContinueClick}>登録完了</button>
            <button type='button' id='btnBack' style={{ margin: '40px' }} onClick={this.handleBtnBackClick}>戻　る</button>
            <button type='button' id='btnCancel' style={{ margin: '40px' }} onClick={this.handleBtnCancelClick}>中　止</button>
          </div>
          <div style={{ fontSize: 'medium', textAlign: 'center' }}>
            ご注意: このページはまだ閉じないでください。<br />ページを閉じたり中止ボタンをクリックした場合、初回登録を最初からやり直していただくことになります。
          </div>
        </div>
      </div>
    )
  }
}

Authentication.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/authentication.js